import script from "./toggle-switch.vue?vue&type=script&setup=true&lang=js"
export * from "./toggle-switch.vue?vue&type=script&setup=true&lang=js"

import "./toggle-switch.vue?vue&type=style&index=0&id=710522de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-710522de"]])

export default __exports__